import React, { useState } from 'react'
import Img from 'gatsby-image'
import FindLocalImage from './findlocalimage'

const LocalImage = ({ filename, alt, ...props }) => {
  const [image, setImage] = useState(FindLocalImage(filename))

  if (!image) {
    return null
  }

  return (
    <Img
      alt={alt ? alt : ''}
      fluid={image.node.childImageSharp.square}
      {...props}
    />
  )
}

export default LocalImage
